import { useState, useEffect } from 'react';
import {
    Grid,
    Paper,
    Typography,
    TextField,
    Box,
    Button,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Select,
    InputLabel,
    FormControl,
    Tab,
    Tabs,
    CircularProgress
} from '@mui/material';
import useAxios from '../../../hooks/useAxios';
import { Alert } from "@mui/material";
import { useSelector } from "react-redux";
function TabPanel({ value, index, children }) {
    return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
}
const SingleTrade =  ({ stockData }) => {
    const placeSingleOrderURL = `${process.env.REACT_APP_APP_TRADE_URL}/trade/place`;
    const getSinglePriceURL = `${process.env.REACT_APP_APP_TRADE_URL}/data/price`;
    const getOrderMapURL = `${process.env.REACT_APP_APP_TRADE_URL}/data/positions-summary`;
    const token =  useSelector((state) => state.user_authentication.token);
    const [orders, setOrders] = useState([]);
    const [symbol, setSymbol] = useState('');
    const [transactionType, setTransactionType] = useState('BUY');
    const [quantity, setQuantity] = useState(0);
    const [strategyType, setStrategyType] = useState('REGULAR');
    const [price, setPrice] = useState(0);
    const [orderMessage, setOrderMessage] = useState('');
    const [severity, setSeverity] = useState('');
    const [tab, setTab] = useState(0);
    const [lastUpdatedOrder, setLastUpdatedOrder] = useState('');
    const [loading, setLoading] = useState(false);

    const {
        data: placeSingleOrder,
        error: errorSingleOrder,
        loading: loadingSingleOrder,
        callAPI: callSingleOrder
    } = useAxios();

    useEffect(() => {
        if (placeSingleOrder && loadingSingleOrder) {

            setLoading(false);
            console.log('placeSingleOrder ', placeSingleOrder);
            if (placeSingleOrder.success && placeSingleOrder.results?.[0]?.success) {
                setOrderMessage(placeSingleOrder.results[0].message);
                setSeverity("success")
            } else {
                setSeverity("warning");
                setOrderMessage("Your order failed. Please try again.");
            }

        } else if (errorSingleOrder) {
            console.error(errorSingleOrder);
            setLoading(false);
            setSeverity("error");
            setOrderMessage("Failed to place order. Please try again.");
        }
    }, ([placeSingleOrder, errorSingleOrder, loadingSingleOrder]));



    const {
        data: getStockPrice,
        error: errorStockPrice,
        loading: loadingStockPrice,
        callAPI: callStockPrice
    } = useAxios();

    useEffect(() => {
        if (getStockPrice && loadingStockPrice) {

            setLoading(false);
            console.log('placeSingleOrder ', getStockPrice);

            if (getStockPrice.success) {
                console.log(price);
                setPrice(getStockPrice.price);
            } else {
                setSeverity("warning");
                setOrderMessage("Get price failed. Please try again.");
            }

        } else if (loadingStockPrice && errorStockPrice) {
            console.error(errorStockPrice);
            setLoading(false);
            setSeverity("error");
            setOrderMessage("Failed to get Price. Please try again.");
        }
    }, ([getStockPrice, errorStockPrice, loadingStockPrice]));


    const {
        data: getOrderMap,
        error: errorOrderMap,
        loading: loadedOrderMap,
        callAPI: callOrderMapAPI
    } = useAxios();

    useEffect(() => {
        if (getOrderMap && loadedOrderMap) {
            setLoading(false);
            setOrders(getOrderMap.positions);
            setLastUpdatedOrder(getOrderMap.last_updated);
            console.log('getOrderMap ', getOrderMap);
        } else if (loadedOrderMap && errorOrderMap) {
            console.error(errorOrderMap);
            setLoading(false);
        }
    }, ([getOrderMap, errorOrderMap, loadedOrderMap]));


    const handleTabChange = (event, newValue) => {
        setTab(newValue);
        setSymbol('');
        setQuantity(0);
        setPrice('');
    };

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    
    const handlePlaceOrder = () => {
        const payload = {
            "orders": [
                {
                    "symbol": symbol,
                    "quantity": quantity,
                    "order_type": transactionType,
                    "strategy": strategyType
                }
            ]
        };
        setLoading(true);
        callSingleOrder(
            placeSingleOrderURL,
            "POST",
            payload,
            {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        )

        setSymbol('');
        setQuantity('');
        setPrice(0);


    };

    const fetchOrders = () => {
        setLoading(true);
        callOrderMapAPI(
            getOrderMapURL,
            'GET',
            null,
            {
                "Authorization": "Bearer " + token,
            }
        );
    };

    useEffect(() => {
        fetchOrders();
    }, []);



    const handleGetPrice = () => {
        setOrderMessage('');
        setLoading(true);
        callStockPrice(
            getSinglePriceURL + `/${symbol}`,
            "GET",
            null,
            {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        )
    }

    const AnyStock = () => {

        return (<>

            <Grid container spacing={2}>


                <Grid item xs={12}>
                    <TextField
                        label="Type Stock"
                        fullWidth
                        value={symbol}
                        onChange={e => setSymbol(e.target.value)}
                    />
                </Grid>



                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel>Transaction Type</InputLabel>
                        <Select
                            value={transactionType}
                            onChange={(e) => setTransactionType(e.target.value)}
                            label="Transaction Type"
                        >
                            <MenuItem value="BUY">BUY</MenuItem>
                            <MenuItem value="SELL">SELL</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel>Strategy</InputLabel>
                        <Select
                            value={strategyType}
                            onChange={(e) => setStrategyType(e.target.value)}
                            label="Strategy"
                        >
                            <MenuItem value="VALUE">REGULAR</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Quantity"
                        fullWidth
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Button
                        variant="contained"
                        onClick={handleGetPrice}
                        fullWidth
                    >
                        Get Price
                    </Button>
                </Grid>

                {price !== null && (
                    <Grid item xs={6}>
                        <Typography variant="body1">
                            Price: ₹{price}
                        </Typography>
                    </Grid>
                )}
            </Grid>

        </>);

    }
    const PortfolioStock = ({ stockData }) => {
        return (<>

            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel>Stock</InputLabel>
                        <Select
                            value={symbol}
                            onChange={e => setSymbol(e.target.value)}
                            label="Stock Symbol"
                        >

                            {stockData.map((stock) => (
                                <MenuItem value={stock.tradingsymbol}>{stock.tradingsymbol}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>



                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <InputLabel>Transaction Type</InputLabel>
                        <Select
                            value={transactionType}
                            onChange={(e) => setTransactionType(e.target.value)}
                            label="Transaction Type"
                        >
                            <MenuItem value="BUY">BUY</MenuItem>
                            <MenuItem value="SELL">SELL</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel>Strategy</InputLabel>
                        <Select
                            value={strategyType}
                            onChange={(e) => setStrategyType(e.target.value)}
                            label="Strategy"
                        >
                            <MenuItem value="REGULAR">REGULAR</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        label="Quantity"
                        fullWidth
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Button
                        variant="contained"
                        onClick={handleGetPrice}
                        fullWidth
                    >
                        Get Price
                    </Button>
                </Grid>

                {price !== null && (
                    <Grid item xs={6}>
                        <Typography variant="body1">
                            Price: ₹{price}
                        </Typography>
                    </Grid>
                )}


            </Grid>

        </>);

    }
    return (
        <Grid container spacing={3} sx={{ mt: 3 }}>
            <Grid item xs={12} md={6}>
                <Paper sx={{ p: 3, color: "#2d4890", border: "1px solid lightgrey" }} >
                    <Tabs value={tab} onChange={handleTabChange} centered>
                        <Tab label="PortFolio Stock" />
                        <Tab label="Any Stock" />
                    </Tabs>
                    <Typography variant="h6" gutterBottom sx={{ padding: "10px", marginTop: "10px" }}>
                        Place New Order
                    </Typography>

                    {loading && (
                        <Box
                            position="absolute"
                            top={350}
                            left={0}
                            width="100%"
                            height="100%"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            zIndex={1000}
                            bgcolor="rgba(255, 255, 255, 0.6)"
                        >
                            <CircularProgress size={40} />
                        </Box>
                    )}

                    <Grid container spacing={2}>

                        <TabPanel value={tab} index={0}>
                            {PortfolioStock(stockData = { stockData })}
                        </TabPanel>
                        <TabPanel value={tab} index={1}>
                            {AnyStock()}
                        </TabPanel>
                    </Grid>

                    {orderMessage && (
                        <Alert severity={severity} sx={{ mt: 2 }}>
                            {orderMessage}
                        </Alert>
                    )}

                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 3, marginLeft: "5px" }}
                        onClick={handlePlaceOrder}
                    >
                        Place Order
                    </Button>
                </Paper>
            </Grid>



            <Grid item xm={12} md={12}>
                <Paper sx={{ p: 3, mb: 3, border: "1px solid lightgrey" }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" gutterBottom>
                            Order Book
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Last updated: {lastUpdatedOrder}
                        </Typography>
                    </Box>
                    <Button variant="outlined" onClick={fetchOrders} sx={{ mb: 2 }}>
                        Refresh Orders
                    </Button>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Trading Symbol</TableCell>
                                    <TableCell>Transaction_type</TableCell>
                                    <TableCell>Quantity</TableCell>
                                    <TableCell>Total Quantity</TableCell>
                                    <TableCell>Current Price</TableCell>
                                    <TableCell>Average Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {orders.map((order, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{order.symbol}</TableCell>
                                        <TableCell>{order["Order Type"]}</TableCell>
                                        <TableCell>{order.quantity}</TableCell>
                                        <TableCell>{order.total_quantity}</TableCell>
                                        <TableCell>{order.current_value}</TableCell>
                                        <TableCell>{order.avg_price}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
        </Grid>);
};

export default SingleTrade;